import { FC } from "react"
import { Outlet } from "react-router"

export const RouteContainer: FC = () => {
	return (<Outlet />);
}